export default __webpack_public_path__ + "static/media/citySpark-price-5000-will-jamous-no-arrows-no-shadow.da863ead.webp";